var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 61,
    viewBox: "0 0 81 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8276 30.3464C51.9721 37.6722 53.0853 46.5902 55.4935 57.3692C55.9046 59.209 57.7293 60.3673 59.5691 59.9562C61.409 59.5451 62.5672 57.7204 62.1562 55.8806C59.6878 44.833 58.6759 36.0312 58.6391 29.1042C69.439 26.6562 75.9808 22.5847 78.8981 17.6376C80.5192 14.8885 80.9412 11.969 80.3316 9.26843C79.7324 6.61398 78.1821 4.36043 76.1696 2.7619C72.1332 -0.444355 65.9166 -1.23744 60.6962 2.6767C56.0245 6.17944 52.7998 12.9503 52.0034 23.4173C45.4262 24.4447 37.1235 24.9874 26.7544 24.7669C24.8696 24.7268 23.3092 26.2222 23.2691 28.107C23.229 29.9917 24.7244 31.5521 26.6092 31.5922C36.6588 31.806 44.9826 31.3275 51.8276 30.3464ZM58.993 21.9951C67.7063 19.7381 71.5989 16.5757 73.0175 14.1699C73.7927 12.8553 73.8833 11.7065 73.6723 10.7716C73.4508 9.79058 72.8474 8.84149 71.9234 8.10756C70.0871 6.6489 67.3003 6.25776 64.7916 8.13877C62.5164 9.84464 59.9234 13.8446 58.993 21.9951Z",
    fill: "url(#paint0_linear_1600_2676)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0854 27.6093L9.18414 19.3168L8.7961 19.3237L7.10585 25.0847L6.26732 25.1025C6.18598 25.1092 6.12471 25.1399 6.08851 25.192C6.0523 25.244 6.0422 25.316 6.05901 25.4021C6.09944 25.5656 6.26176 25.6993 6.41282 25.6989L6.94545 25.7057L6.39349 27.7172L10.0854 27.6093Z",
    fill: "url(#paint1_linear_1600_2676)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0847 27.6101L9.18344 19.3176L8.7954 19.3246L7.10515 25.0856L6.26663 25.1033C6.18529 25.1101 6.12401 25.1407 6.08781 25.1928C6.05161 25.2449 6.0415 25.3169 6.05831 25.4029C6.09875 25.5664 6.26106 25.7002 6.41212 25.6998L6.94475 25.7066L6.39279 27.718L10.0847 27.6101Z",
    fill: "url(#paint2_linear_1600_2676)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60199 26.7951C2.63372 26.8667 -0.0294152 27.3781 0.241593 28.4344C0.512602 29.4908 3.41337 29.9344 7.39292 29.8943L10.7356 29.7086C13.9543 29.4139 16.9526 28.8561 16.9526 28.8561L19.5596 31.183L19.9118 31.1802L18.6439 28.7714C18.6439 28.7714 19.4791 28.7191 19.3439 28.1875C19.2086 27.6558 18.3534 27.6229 18.3534 27.6229L18.4014 25.1984L18.0365 25.1905L16.621 27.5704C16.621 27.5704 13.3487 27.1012 10.0045 26.8846L6.60199 26.7951Z",
    fill: "url(#paint3_linear_1600_2676)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89991 31.5868L8.74791 31.577L13.3352 37.2601L13.7232 37.2531L10.7291 29.7035L7.38637 29.8892L8.27005 30.9853L7.73622 30.9799C7.65488 30.9867 7.5936 31.0173 7.5574 31.0694C7.52119 31.1215 7.51109 31.1935 7.5279 31.2795C7.58413 31.4563 7.74644 31.59 7.89991 31.5868Z",
    fill: "url(#paint4_linear_1600_2676)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90057 31.5859L8.74857 31.5762L13.3359 37.2593L13.7239 37.2523L10.3543 28.7323L6.5542 28.8472L8.2707 30.9844L7.73687 30.9791C7.65553 30.9859 7.59426 31.0165 7.55805 31.0686C7.52185 31.1207 7.51174 31.1926 7.52856 31.2787C7.58478 31.4555 7.7471 31.5892 7.90057 31.5859Z",
    fill: "url(#paint5_linear_1600_2676)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1600_2676",
    x1: 17.947,
    y1: 12.0834,
    x2: 62.3269,
    y2: 57.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1600_2676",
    x1: 17.947,
    y1: 12.0834,
    x2: 62.3269,
    y2: 57.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1600_2676",
    x1: 17.947,
    y1: 12.0834,
    x2: 62.3269,
    y2: 57.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1600_2676",
    x1: 17.947,
    y1: 12.0834,
    x2: 62.3269,
    y2: 57.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1600_2676",
    x1: 17.947,
    y1: 12.0834,
    x2: 62.3269,
    y2: 57.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1600_2676",
    x1: 17.947,
    y1: 12.0834,
    x2: 62.3269,
    y2: 57.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2f12ef88.svg";
export { ForwardRef as ReactComponent };